import { render, staticRenderFns } from "./TodoCard.vue?vue&type=template&id=777f1af7&"
import script from "./TodoCard.vue?vue&type=script&lang=js&"
export * from "./TodoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports